/**
 * API Configuration
 * Centralized API base URL configuration
 * 
 * Default: https://ecourt.n2nai.io/api
 * Override: Set VITE_API_BASE_URL in .env file
 */

// API Base URL - Always use domain backend
// Remove trailing slash to avoid double slashes
const rawUrl = import.meta.env.VITE_API_BASE_URL || 'https://ecourt.n2nai.io/api'
export const API_BASE_URL = rawUrl.endsWith('/') ? rawUrl.slice(0, -1) : rawUrl

// Log for debugging (only in development)
if (import.meta.env.DEV) {
  console.log('🌐 API Base URL:', API_BASE_URL)
}
